import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Gray300, Gray50, Gray800 } from "../../../styles/color";
import {
  MediaStyleProperties,
  StyledComponentProps,
} from "../../../system/types/style/StyledComponentProps";

const MeetingRoomListULMaxHeight: MediaStyleProperties = {
  pc: "calc(100% - 89px - 16px)",
  tablet: "calc(100% - 89px - 16px)",
  mobile: "88px",
};

export const MeetingRoomListUL = styled.ul<StyledComponentProps>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 8;
  overflow-y: auto;
  min-height: ${({ deviceType }) => MeetingRoomListULMaxHeight[deviceType]};
  max-height: ${({ deviceType }) => MeetingRoomListULMaxHeight[deviceType]};
  scrollbar-gutter: stable;
`;

export const MeetingRoomStatusLegendWrapper = styled(Box)({
  display: "flex",
  flex: 1,
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  marginRight: "4px",
});

export const MeetingRoomStatusLegendRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  gap: "8px",
  alignItems: "center",
});

export const MeetingRoomStatusLegendBox = styled(Box)({
  width: "14px",
  height: "14px",
  borderRadius: "4px",
});

export const MeetingRoomStatusLegendText = styled(Box)({
  display: "flex",
  fontSize: "0.725rem",
  "&:last-child": {
    marginRight: 0,
  },
});

export const MeetingRoomFloorNameBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  minWidth: "64px",
  color: Gray800,
  fontSize: "14px",
  letterSpacing: "0.05em",
});

export const MeetingRoomListItemWrapper = styled.div<StyledComponentProps>`
  display: flex;
  gap: 8px;
  width: 100%;
`;
/* 
export const MeetingRoomListItemWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
}); */

export const NoRegisterRoomMessage = styled(Typography)({
  width: "100%",
  boxSizing: "border-box",
  padding: "2px 4px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Gray50,
  border: `2px dashed ${Gray300}`,
  borderRadius: "4px",
  fontSize: "0.875rem",
  cursor: "not-allowed",
  boxShadow: `
  0px 2px 1px -1px rgba(0, 0, 0, 0.1), 
  0px 1px 1px 0px rgba(0, 0, 0, 0.08)
  `,
});
